import React from 'react';
import { Link } from 'react-router-dom';

const Register = () => {
    return (
        <div className="login-form">
            <div>
                <h2>Please Register</h2>
                <form>
                    <input type="email" name="" id="" placeholder="Your email" />
                    <br /><br />
                    <input type="password" name="" id="" placeholder="Your password"/>
                    <br /><br />
                    <input type="password" name="" id="" placeholder="Re-enter password"/>
                    <br /><br />
                    <input type="submit" value="Submit" />
                </form>
                <p>Already have an account? <Link to="/login">Login</Link> </p>
                <div>------------- or --------------</div>
                <button className="button">Google Sing In</button>
            </div>
        </div>
    );
};

export default Register;